


























































import BaseComponent from '@/components/base-component.vue';
import ParametersEditModal from '@/components/parameters/edit-modal.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiReferencesTypesHierarchy from '@/components/UI/references-types-hierarchy/index.vue';
import { toNumber } from '@/helpers/toNumber';
import ParameterModel from '@/models/parameter-model';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    UiReferencesTypesHierarchy,
    ParametersEditModal,
  },
})
export default class ParametersFormPatientClassification extends BaseComponent {
  @Prop()
  public editItem: any;
  @Prop()
  public modalOpen: boolean;

  public item: ParameterModel = new ParameterModel();
  public range: any = {};

  public rules: any = {
    newborn: [(val) => !!toNumber(val) || 'Digite um valor maior que 0'],
    pediatric: (range) => [
      (val) => !!toNumber(val) || 'Digite um valor maior que 0',
      (val) =>
        toNumber(val) > range.newborn ||
        `Digite um valor maior que ${range.newborn}`,
    ],
    adult: (range) => [
      (val) => !!toNumber(val) || 'Digite um valor maior que 0',
      (val) =>
        toNumber(val) > range.pediatric ||
        `Digite um valor maior que ${range.pediatric}`,
    ],
  };

  get hintNewborn(): string {
    return `Idade em dias menor ou igual a ${this.range.newborn}`;
  }

  get hintPediatric(): string {
    return `Idade em dias maior ou igual a ${this.range.pediatric} e menor que ${this.range.adult}`;
  }

  get hintAdult(): string {
    return `Idade em dias maior ou igual a ${this.range.adult}`;
  }

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new ParameterModel();

    if (!val) {
      return;
    }

    this.item = new ParameterModel(this.editItem);
    this.setRange();
  }

  @Watch('range', { deep: true })
  public onChangeRange(val: any): void {
    this.range.pediatric = toNumber(this.range.newborn) + 1;
    this.item.valores.filter(v => v.identificacao == 'NEO_NATAL')[0].valor = val.newborn;
    this.item.valores.filter(v => v.identificacao == 'PEDIATRICO')[0].valor = val.pediatric;
    this.item.valores.filter(v => v.identificacao == 'ADULTO')[0].valor = val.adult;
  }

  public setRange(): void {
    this.range = {
      newborn:
        this.item.valores.findIndex(v => v.identificacao == 'NEO_NATAL') != -1 ? toNumber(this.item.valores.filter(v => v.identificacao == 'NEO_NATAL')[0].valor) : 0,
      pediatric:
        this.item.valores.findIndex(v => v.identificacao == 'PEDIATRICO') != -1 ? toNumber(this.item.valores.filter(v => v.identificacao == 'PEDIATRICO')[0].valor) : 0,
      adult:
        this.item.valores.findIndex(v => v.identificacao == 'ADULTO') != -1 ? toNumber(this.item.valores.filter(v => v.identificacao == 'ADULTO')[0].valor) : 0,
    };
  }

  public beforeMount(): void {
    this.onEditItemChanges(this.editItem);
  }

  public onClose(): void {
    this.$emit('close');
  }
}
